module.exports = __webpack_public_path__ + "img/strenth+4.cd58fe32.webp";